export default "__VITE_ASSET__GfZgfQB0__"